export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/MySWalletLogo.03abd929.svg","height":51,"width":162,"blurWidth":0,"blurHeight":0};